import { render, staticRenderFns } from "./alertBox.vue?vue&type=template&id=168cbe0a&scoped=true&"
import script from "./alertBox.vue?vue&type=script&lang=js&"
export * from "./alertBox.vue?vue&type=script&lang=js&"
import style0 from "./alertBox.vue?vue&type=style&index=0&id=168cbe0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168cbe0a",
  null
  
)

export default component.exports